export default function (req, res, next) {
  // Set hostname to process, so we can easily use it in plugins/theme.js
  process.host = req.headers['x-forwarded-host'] || req.headers.host;

  next();
}
